// extracted by mini-css-extract-plugin
export var body = "_kg-5";
export var closeButton = "_kg-f";
export var container = "_kg-1";
export var content = "_kg-2";
export var cta = "_kg-c";
export var ctaLabel = "_kg-b";
export var eyebrow = "_kg-3";
export var howTo = "_kg-6";
export var image = "_kg-e";
export var modal = "_kg-0";
export var socialButton = "_kg-d";
export var stepCard = "_kg-8";
export var stepLabel = "_kg-a";
export var stepNumber = "_kg-9";
export var steps = "_kg-7";
export var title = "_kg-4";